import { RouteInfo } from "./sidebar.metadata";
export const ROUTES: RouteInfo[] = [


  {
    path: "/admin/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },



  {
    path: "/admin/job-details/applicant-profile",
    title: "Profile",
    moduleName: "profile-applicant",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: [""],
    submenu: [],
  },

  // {
  //   path: "/admin/job-details/applicant-documents",
  //   title: "Documents",
  //   moduleName: "documents-applicant",
  //   iconType: "feather",
  //   icon: "grid",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["All"],
  //   privilege: [""],
  //   submenu: [],
  // },
  {
    path: "/admin/job-details/all-job-openings",
    title: "Job Openings",
    moduleName: "openings-applicant",
    iconType: "feather",
    icon: "grid",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: [""],
    submenu: [],
  },

  {
    path: "/admin/job-details/all-job-applications",
    title: "My Applications",
    moduleName: "applications-applicant",
    iconType: "feather",
    icon: "file-text",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: [""],
    submenu: [],
  },

  {
    path: "/admin/job-details/notifications",
    title: "Notifications",
    moduleName: "notifications-applicant",
    iconType: "feather",
    icon: "bell",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: [""],
    submenu: [],
  },

  {
    path: "",
    title: "Settings",
    moduleName: "settings",
    iconType: "feather",
    icon: "settings",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: [""],
    submenu: [
      {
        path: "/admin/job-details/reset-password",
        title: "Reset Password",
        moduleName: "reset-password",
        iconType: "feather",
        icon: "lock",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: ["All"],
        privilege: [""],
        submenu: [],
      },
    ],
  },

];
